<template>
  <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="center" align="top" :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="ijazah">
            <a-input
              autocomplete="off"
              v-decorator="['no_ijazah', {rules: [{required: true}], initialValue: initial.no_ijazah}]"
            />
          </a-form-item>
          <a-form-item label="Asal Universitas">
            <a-input
              autocomplete="off"
              v-decorator="['asal_univ', {rules: [{required: true}], initialValue: initial.asal_univ}]"
            />
          </a-form-item>
          <a-form-item label="Tahun Lulus">
            <a-input
              autocomplete="off"
              maxlength="4"
              v-decorator="['thn_lulus', {rules: [{required: true}], initialValue: initial.tahun_lulus}]"
            />
          </a-form-item>
          <a-form-item label="Pendidikan Terakhir">
            <a-select
              v-decorator="['pendidikan_akhir', {rules: [{required: true}], initialValue: initial.pendidikan_terakhir}]"
            >
              <a-select-option key="1" value="SMP">SMP</a-select-option>
              <a-select-option key="2" value="SMA">SMA</a-select-option>
              <a-select-option key="3" value="D1">D1</a-select-option>
              <a-select-option key="4" value="D2">D2</a-select-option>
              <a-select-option key="5" value="D3">D3</a-select-option>
              <a-select-option key="6" value="D4">D4</a-select-option>
              <a-select-option key="7" value="S1">S1</a-select-option>
              <a-select-option key="8" value="S2">S2</a-select-option>
              <a-select-option key="9" value="S3">S3</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="No. NPWP">
            <a-input autocomplete="off" v-decorator="['npwp', {initialValue: initial.no_npwp }]" />
          </a-form-item>
          <a-form-item label="No. Ketenagakerjaan">
            <a-input
              autocomplete="off"
              v-decorator="['no_kpj', {initialValue: initial.no_tenagakerja}]"
            />
          </a-form-item>
          <a-form-item label="BPJS">
            <a-input
              autocomplete="off"
              v-decorator="['no_bpjs', {initialValue: initial.no_bpjs}]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
export default {
  name: "document",
  props: ["data", "mode"],
  data() {
    return {
      document: {}
    };
  },
  computed: {
    initial() {
      let initialData = {};
      if (this.mode == "edit") {
        initialData = {
          asal_univ: this.data.dokumen.asal_univ,
          bank: this.data.dokumen.bank,
          no_bpjs: this.data.dokumen.no_bpjs,
          no_ijazah: this.data.dokumen.no_ijazah,
          no_npwp: this.data.dokumen.no_npwp,
          no_rekening: this.data.dokumen.no_rekening,
          no_tenagakerja: this.data.dokumen.no_tenagakerja,
          pendidikan_terakhir: this.data.dokumen.pendidikan_terakhir,
          tahun_lulus: this.data.dokumen.tahun_lulus
        };
      }
      return initialData;
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("createKaryawan", values);
      });
    }
  }
};
</script>

<style>
</style>